{
  "15852ba9fdafaa1c": "Descarga la aplicación móvil de Clipboard Workplace",
  "28d03596d24eeb4e": "Saltar",
  "355f5e74848522db": "iOS",
  "358a97b9bb66c070": "Error al actualizar. Por favor, intenta de nuevo.",
  "3d56ae33bf72d534": "¿Qué tipos de turnos quieres publicar primero?",
  "5256900289c82266": "Invitar a personal",
  "5cff875ddac5c777": "Ve qué más puedes hacer",
  "6a58cf22edab0bf9": "Publica tus necesidades de personal",
  "6a9e16f0fb0cd7ae": "¡Invita a los profesionales que conoces a unirse a Clipboard contigo!",
  "6d612a86bee4b0a6": "Android",
  "7be9efc23bd18b68": "ofrecer un bloque de turnos",
  "8640d6e1e13d439c": "¡Has publicado tu primera solicitud de personal!",
  "981038b9aea98b69": "Invitar al personal",
  "983f311018642b0a": "Empezar",
  "9ceda19cf812ec8a": "Publica tu primer turno",
  "aa26583ec8dbfb73": "Así es como puedes comenzar...",
  "ac70249101626e2d": "Llena tus turnos con profesionales de confianza",
  "ad1e8b5af91b0b2e": "Modal de Publicación de Turnos Intermedia",
  "b7b7cd05c471d63b": "Publica más turnos",
  "d3159e27a9330927": "Publicar turnos",
  "e789a9857da6e2b1": "¡Puedes invitar al personal a unirse a Clipboard en cualquier momento!",
  "eeeef2e208677554": "Administra tu horario, publica turnos y envía mensajes a los trabajadores mientras estás en movimiento.",
  "efd29d8c54d0a8ff": "Lleva Clipboard contigo"
}
